// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"b9ef395a","161":"7005eab0","411":"45c8aa9a","453":"ae97541e","643":"35b443e7"}[chunkId] + ".chunk.js";
};